<div class="col">
  <p>
    {{
      'document-view-public.document-view-referenced.type-for'
        | translate: { type: typeName }
        | pepUcfirst
    }}:
    <span *ngFor="let doc of documents">
      <br *ngIf="documents.length > 1" />
      {{ doc.type | translate | pepUcfirst }}
      {{ doc.number }}
      <button
        *ngIf="link"
        type="button"
        class="btn btn-link btn-sm pl-0"
        routerLink="../../view/{{ doc.id }}"
      >
        <i class="fe fe-external-link"></i>
      </button>
    </span>
  </p>
</div>
